module.exports = __webpack_public_path__ + "img/moniter-01.7367b2d4.png";